import { render } from "./ProductsDetailView.vue?vue&type=template&id=665da724"
import script from "./ProductsDetailView.vue?vue&type=script&lang=js"
export * from "./ProductsDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__